import dynamic from 'next/dynamic';
import React from 'react';
import LayoutComponent from '../../components/home/layouts/LayoutComponent';
import { initializeApollo } from '../../../apollo-ssr';
import GET_COURSE_DETAILS from '../../gql/queries/get-course-details.gql';
import { getServerSideToken } from '../../utils/auth-utils';

const Course = dynamic(() => import('../../components/course/course'), { ssr: true });

function CourseWrapper() {
  return (
    <Course />
  );
}

CourseWrapper.getLayout = function getLayout(page) {
  return (
    <LayoutComponent pageTitle="Home" headerType="2" paddingClass="p-0" pageName="courseDetail">
      {page}
    </LayoutComponent>
  );
};

export async function getServerSideProps(context) {
  let hostname;
  if (context && context.req && context.req.headers && context.req.headers.host) {
    hostname = context.req.headers.host;
  } else {
    // Fallback if no context provided
    hostname = 'nextias.com';
  }
  const userToken = getServerSideToken(context.req);
  const apolloClient = initializeApollo(null, userToken, hostname);

  let slug;
  if (context && context.params && context.params.slug) {
    slug = context.params.slug;
  } else {
    slug = null;
  }

  try {
    const queryPromises = [
      apolloClient.query({
        query: GET_COURSE_DETAILS,
        variables: { slug },
        errorPolicy: 'ignore',
      }),
    ];

    const queryResults = await Promise.allSettled(queryPromises);

    const [onlineCourseResult] = queryResults;

    const initialOnlineCourseData = onlineCourseResult.status === 'fulfilled'
      ? onlineCourseResult.value.data
      : null;

    queryResults.forEach((result, index) => {
      if (result.status === 'rejected') {
        console.error(`Query ${index} failed:`, result.reason);
      }
    });

    return {
      props: {
        initialOnlineCourseData,
        apolloState: apolloClient.cache.extract(),
      },
    };
  } catch (error) {
    console.error('Error fetching courses data:', error);
    return {
      props: {
        initialOnlineCoursesData: null,
        apolloState: apolloClient.cache.extract(),
      },
    };
  }
}

export default CourseWrapper;
